const monthlyFields = `
  cost
  credit
  tax
  discountedUsage
  fee
  refund
  riFee
  savingPlanRecurringFee
  savingPlanUpfrontFee
  savingsPlanCoverage
  savingsPlanNegation
`

const yearlyFields = `
  _0 { ${monthlyFields} }
  _1 { ${monthlyFields} }
  _2 { ${monthlyFields} }
  _3 { ${monthlyFields} }
  _4 { ${monthlyFields} }
  _5 { ${monthlyFields} }
  _6 { ${monthlyFields} }
  _7 { ${monthlyFields} }
  _8 { ${monthlyFields} }
  _9 { ${monthlyFields} }
  _10 { ${monthlyFields} }
  _11 { ${monthlyFields} }
`

export const GET_ACTUALS = `
  mutation ($year: Int!) {
    getUsageDetailsForUserNew(actualsSearch: {year: $year}) {
      data {
        element1
        element2
        element3
        element4
        accountId
        accountName
        percentage
        startDate
        endDate
        values { ${yearlyFields} }
        claimedValues { ${yearlyFields} }
        sharedValues { ${yearlyFields} }
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
